export class ResetRedirectUrl {
    static readonly type = '[Auth] ResetRedirectUrl';
}
